// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const HpeIcon = createSvgIcon(
  <svg strokeWidth={36} viewBox="0 0 630 180">
    <path
      fill="none"
      stroke="currentColor"
      d="M18 180V0m154 180V0M18 89h137m95 91V0m0 18h102a32 32 0 0 1 0 100H250m222-67V18h158"
    />
    <path fill="none" stroke="#03a883" d="M630 162H472V86h158" />
  </svg>,
  "Hpe",
);
export default HpeIcon;
